import { apiRequest, apiUrl, isBackendConfigured } from '../backend/api';

export async function signInWithGoogle(): Promise<{ ok: boolean; message: string }> {
  if (!isBackendConfigured()) return { ok: false, message: 'Cloud sign-in is not configured in this build.' };
  window.location.assign(apiUrl('/auth/google/start'));
  return { ok: true, message: 'Opening secure Google sign-in…' };
}

export async function signOut(): Promise<{ ok: boolean; message: string }> {
  if (!isBackendConfigured()) return { ok: false, message: 'Cloud sign-in is not configured in this build.' };
  await apiRequest('/auth/logout', { method: 'POST' });
  return { ok: true, message: 'Logged out. Local guest progress stays on this device.' };
}

export async function signedInAlias(): Promise<string | null> {
  if (!isBackendConfigured()) return null;
  try {
    return (await apiRequest<{ alias: string }>('/auth/me')).alias;
  } catch {
    return null;
  }
}
